import { Outlet, ScrollRestoration } from 'react-router-dom';

import { LoadingZone, SuspenseZone } from '@zenbusiness/application-commons-loading';
import PageError from '@zenbusiness/zui/PageError';

import { NAME } from '#client/build-env';
import ShoppingErrorBoundary from '#client/components/ShoppingErrorBoundary';
import TrackPageView from '#client/components/TrackPageView';

/**
 * Router outlet which sets up a SuspenseZone for react lazy loading of page components
 * @param {object} props
 * @param {*} [props.children]
 * @component
 */
export default function PostRouting({ children }) {
  return (
    <ShoppingErrorBoundary fallback={<PageError />} id={`${NAME}/App/PostRouting`}>
      <ScrollRestoration />
      <LoadingZone bubble loadId="PostRouting" timeout={10000}>
        <TrackPageView />
        <SuspenseZone loadId="PostRouting Suspense">{children || <Outlet />}</SuspenseZone>
      </LoadingZone>
    </ShoppingErrorBoundary>
  );
}
